export enum ROLE {
  SUPER_ADMIN = 'CCI_ADMIN',
  ADMIN = 'CCI_CONFERENCE_USER',
  COMPANY = 'COMPANY_ADMIN',
}
